import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-sm font-medium text-[#404040]" }
const _hoisted_2 = {
  key: 0,
  class: "ml-1 rounded-full bg-[#48DDC3] px-2 py-0.5 text-xs text-white"
}
const _hoisted_3 = {
  autocomplete: "off",
  class: "flex flex-col gap-4"
}
const _hoisted_4 = { class: "mb-1 block text-sm font-medium text-gray-800" }
const _hoisted_5 = { class: "mb-1 block text-sm font-medium text-gray-800" }
const _hoisted_6 = { class: "mb-1 block text-sm font-medium text-gray-800" }
const _hoisted_7 = { class: "mt-6 grid grid-cols-2 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: $setup.filterOpened,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.filterOpened) = $event)),
    title: $setup.t('aura.filters.filter')
  }, {
    button: _withCtx(() => [
      _createElementVNode("button", {
        class: "aura-filters-button flex items-center gap-2 rounded-[10px] border border-[#D4D4D4] bg-white px-3 py-2 hover:bg-gray-50",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.filterOpened = true))
      }, [
        _createVNode($setup["FilterIcon"], {
          class: "h-4 w-4 text-[#737373]",
          "aria-hidden": "true"
        }),
        _createElementVNode("span", _hoisted_1, _toDisplayString($setup.t('aura.filters.filter')), 1 /* TEXT */),
        ($setup.hasActiveFilters)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.activeFilterCount), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_3, [
        _createCommentVNode(" Operator "),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_4, _toDisplayString($setup.t('aura.filters.operator')), 1 /* TEXT */),
          _createVNode(_component_UiMultiselect, {
            modelValue: $setup.draftFilters.operatorId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.draftFilters.operatorId) = $event)),
            name: "operator",
            options: $setup.users,
            label: "name",
            "value-prop": "id",
            "can-clear": "",
            placeholder: $setup.t('aura.filters.selectOperator'),
            loading: $setup.isLoadingUsers,
            searchable: "local",
            "allow-empty": true,
            "show-labels": false
          }, null, 8 /* PROPS */, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _createCommentVNode(" Queue "),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_5, _toDisplayString($setup.t('aura.filters.queue')), 1 /* TEXT */),
          _createVNode(_component_UiMultiselect, {
            modelValue: $setup.draftFilters.queueId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.draftFilters.queueId) = $event)),
            name: "queue",
            options: $setup.queues,
            label: "name",
            "value-prop": "id",
            "can-clear": "",
            placeholder: $setup.t('aura.filters.selectQueue'),
            loading: $setup.isLoadingQueues,
            searchable: "local",
            "allow-empty": true,
            "show-labels": false
          }, null, 8 /* PROPS */, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _createCommentVNode(" Media (Number Media) "),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_6, _toDisplayString($setup.t('aura.filters.media')), 1 /* TEXT */),
          _createVNode(_component_UiMultiselect, {
            modelValue: $setup.draftFilters.mediaId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.draftFilters.mediaId) = $event)),
            name: "media",
            options: $setup.medias,
            label: "label",
            "value-prop": "value",
            primitive: true,
            "can-clear": "",
            placeholder: $setup.t('aura.filters.selectMedia'),
            loading: $setup.isLoadingMedias,
            searchable: "local",
            "allow-empty": true,
            "show-labels": false
          }, null, 8 /* PROPS */, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _createCommentVNode(" Action Buttons "),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "gray-700",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clearFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('aura.filters.clear')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_UiButton, {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.applyFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('core.actions.Apply')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "title"]))
}